/**
 * PPR-3 · 上架中心「同行站」页签 / 以同行身份预览 · 服务层。
 * 真契约源：apps/api-server/src/api_server/routes/partner_site_admin.py（PPR-1 清单 + PPR-3 D 预览令牌）。
 * 前端只读接口给的数，不做价格 / 展示判断（铁律十三）。
 */
import { api } from "./api";

export interface PartnerSiteItem {
  product_id: string;
  code: string;
  name_cn: string;
  cover_url: string | null;
  partner_visible: boolean;
  partner_sort: number | null;
  retail_from_cents: number | null;
  settlement_from_cents: number | null;
  display_status: "showing" | "hidden" | "not_showing";
  reason_code: string | null;
  reason_label: string | null;
}
export interface PartnerSiteList {
  items: PartnerSiteItem[];
  counts: { all: number; showing: number; hidden: number; not_showing: number };
}
export interface PartnerSiteUpdate { product_id: string; partner_visible: boolean; partner_sort: number | null }
export interface PreviewPartner { partner_id: string; code: string; name_cn: string; previewable: boolean; reason: string | null }
export interface PartnerPreviewToken { token: string; path: string; expires_at: string; expires_in: number; partner_name: string }

export const PARTNER_SITE_QK = {
  list: ["partner-site", "products"] as const,
  previewPartners: ["partner-site", "preview-partners"] as const,
};

export const getPartnerSiteProducts = (): Promise<PartnerSiteList> => api("/api/v1/partner-site/products");
export const putPartnerSiteProducts = (items: PartnerSiteUpdate[]): Promise<PartnerSiteList> =>
  api("/api/v1/partner-site/products", { method: "PUT", body: JSON.stringify(items) });
export const getPreviewPartners = (): Promise<PreviewPartner[]> => api("/api/v1/partner-site/preview-partners");
export const createPartnerPreviewToken = (partnerId: string): Promise<PartnerPreviewToken> =>
  api("/api/v1/partner-site/preview-token", { method: "POST", body: JSON.stringify({ partner_id: partnerId }) });

/** 「以同行身份预览」：现取令牌 → 新窗口打开同行站（令牌放 URL 片段，不进服务器日志 / Referer）。失败时关掉空白窗口并抛错。 */
export async function openPartnerPreview(partnerId: string): Promise<void> {
  const win = window.open("", "_blank");
  try {
    const t = await createPartnerPreviewToken(partnerId);
    if (win) { win.opener = null; win.location.href = t.path; } else window.location.assign(t.path);
  } catch (e) {
    win?.close();
    throw e;
  }
}

export const usdFromCents = (c: number | null | undefined) => (c == null ? "—" : `$${(c / 100).toLocaleString("en-US", { maximumFractionDigits: 2 })}`);
